<template><div class="unit-vpn" :class="{padded:!info}">
  <loading v-if="!unit || !fleet" />
  <div v-else-if="!fleet.vpn" class="error">
    You do not have access to this unit via VPN.
    <p>Please contact your account administrator to request access.</p>
    <!-- TODO link to account administrator's email address -->
  </div>
  <div v-else-if="!unit.online">
    {{ unit.name }} is <b class="error">offline</b>.
    <p>VPN access is only available when the unit is on-line.</p>
  </div>
  <div v-else-if="!info">
    <template v-if="idle">
      <span class="error" v-if="infoError">Failed to connect. Try again? &nbsp;</span>
      <span v-else>Ready to connect to unit. &nbsp;</span>
      <template v-if="unit.nPorts > 1">
        <button @click="connect(0)">Connect to device 1...</button>
        &nbsp;
        <button @click="connect(1)">Connect to device 2...</button>
      </template>
      <template v-else>
        <button @click="connect(0)">Connect Now...</button>
      </template>
    </template>
    <template v-else>
      <loading />
    </template>
  </div>
  <div v-else class="fill flex">
    <div class="flex-toolbar">
      <!--<router-link :to="`/u/${id}/v/i`">Info</router-link>-->
      <router-link :to="`/u/${id}/v/l`">Logs</router-link>
      <router-link :to="`/u/${id}/v/s`" v-if="sdcard">SD Card</router-link>
      <router-link :to="`/u/${id}/v/u`">Update</router-link>
    </div>
    <div class="flex-fill padded scroll selectable">
      <router-view :api="api" :info="info" @disconnect="info=null" />
    </div>
  </div>
</div></template>
<script>
import Loading from './Loading'
//import ModalDialog from './ModalDialog'
import TecuApi from '../../common-ui/TecuApi'
export default {
  name: 'unit-vpn',
  components: {
    Loading,
    //ModalDialog,
  },
  data() {
    return {
      api: null,
      info: null,
      infoError: null,
      port: 0,
    }
  },
  computed: {
    id() { return this.$store.state.selectedUnit },
    unit() { return this.$store.state.units[this.id] },
    fleet() { return this.$store.getters.unit_fleet[this.id] },
    state() { return this.api && this.api.state },
    idle() { return this.state === TecuApi.IDLE },
    sdcard() {
      return (
        this.info
        && this.info.headers
        && this.info.headers.indexOf('COMMON_SDCARD') >= 0
      )
    },
  },
  created() { this.resetAPI() },
  watch: {
    id() { this.resetAPI() },
    port() { this.resetAPI() },
    info(nv, ov) {
      if (nv && !ov && this.$route.meta.title === 'VPN') {
        this.$router.push(`/u/${this.id}/v/l`)
      } else if (!nv) {
        this.resetAPI()
      }
    },
  },
  methods: {
    resetAPI() {
      if (this.api) this.api.cancel()
      this.api = this.id ? new TecuApi(`/proxy/${this.id}/${this.port}`) : null
      this.info = null
    },
    async connect(port) {
      this.port = port
      for (let i=0; i<2; i++) {
        try {
          this.info = await this.api.getInfo()
          this.infoError = false
        } catch(e) {
          this.infoError = true
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
